// extracted by mini-css-extract-plugin
module.exports = {"ECOMode-detail":"ECOMode_ECOMode-detail__1uSzM"};